import { Feed, MaterialsService } from '../api';

interface FeedsProviderResource {
  getList: (
    resource: string,
    params: any
  ) => Promise<{ data: Feed[] | undefined; total: number | undefined }>;
  getOne: (resource: string, params: any) => Promise<{ data: Feed }>;
  create: (resource: string, params: any) => Promise<{ data: Feed }>;
  update: (resource: string, params: any) => Promise<{ data: Feed }>;
  delete: (resource: string, params: any) => Promise<{ data: {} }>;
  getMany: (resource: string, params: any) => Promise<{ data: Feed[] }>;
  getManyReference: (
    resource: string,
    params: any
  ) => Promise<{ data: Feed[] }>;
  updateMany: (resource: string, params: any) => Promise<{ data: Feed[] }>;
  deleteMany: (resource: string, params: any) => Promise<{ data: {} }>;
}

export const feedsDataProvider: FeedsProviderResource = {
  getList: async (resource, params) => {
    const { pagination } = params;
    console.log('getList', pagination);
    const data = await MaterialsService.getFeeds();
    if (!data) {
      return {
        data: [],
        total: 0,
      };
    }
    return {
      data: data.items,
      total: data.items?.length,
    };
  },
  getOne: async (resource, params) => {
    const { id } = params;

    const feed = await MaterialsService.getFeedById(id);
    return {
      data: feed,
    };
  },
  create: async (resource, params) => {
    const feed = await MaterialsService.createFeeds(params.data);
    return {
      data: feed,
    };
  },
  update: async (resource, params) => {
    const feed = await MaterialsService.updateFeedById(params.id, params.data);
    return {
      data: feed,
    };
  },
  delete: async (resource, params) => {
    const { id } = params;
    await MaterialsService.deleteFeedById(id);
    return {
      data: {},
    };
  },
  getMany: async (resource, params) => {
    const { ids } = params;
    const feeds = await Promise.all(
      ids.map((id: number) => MaterialsService.getFeedById(String(id)))
    );
    return {
      data: feeds,
    };
  },
  getManyReference: async (resource, params) => ({
    data: [],
  }),
  updateMany: async (resource, params) => ({
    data: [],
  }),
  deleteMany: async (resource, params) => {
    // const promises = params.ids.map((id: number) => UserService.deleteUser(id));
    const promises = params.ids.map((id: number) => console.log(id));

    await Promise.all(promises);

    return {
      data: {},
    };
  },
};
